import { useApi } from './api';
import { readJsonApiResponse, type ApiResponse } from './apiResponse';
import type { DatabaseHealthResponse } from '../types/databaseHealth';

export const useDatabaseHealthService = () => {
  const { apiFetch } = useApi();

  const checkDatabaseHealth = async (): Promise<ApiResponse<DatabaseHealthResponse | null>> => {
    try {
      const response = await apiFetch('/health/database');
      return readJsonApiResponse(response, 'Error al verificar la salud de la base de datos', null);
    } catch (error) {
      console.error('Error checking database health:', error);
      return {
        ok: false,
        status: 500,
        data: null,
        error: error instanceof Error ? error.message : 'Error de conexión'
      };
    }
  };

  return { checkDatabaseHealth };
};
